<template>
    <section
    class="content"
    v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.GIS_USER]"
    >
      <div>
        <div class="box-body">
          <div class="sorting">
            <div class="col-md-8">
              <select class="form-control" @change="fiteredResult" v-model="statusValue">
                <option value="" disabled>All</option>
                <option value="scheduled">Scheduled</option>
                <option value="ongoing">Ongoing</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </div>
            <div class="col-md-4">
              <button class="btn inline" @click="clearStatus" >Clear</button>
            </div>
          </div>
          <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
          >
            <router-link :to="{ name: 'TripCreate' }">
              <button class="btn addnew">Add New</button>
            </router-link>
          </div>
          <v-server-table
            ref="tripTable"
            url
            :columns="columns"
            :options="options"
            v-on:row-click="edit"
            @loaded="onLoaded"
          >
            <template slot="beforeBody">
              <tr v-if="loading" class="VueTables__no-results">
                <td class="text-center" colspan="9">
                  <pulse-loader></pulse-loader>
                </td>
              </tr>
            </template>
            <template slot="edit" slot-scope="props" >
              <div v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]">
                <a v-if = "props.row.status == 'ongoing'"
                class="fa fa-edit"
                role="button"
                v-on:click.stop="UpdateDestination(props.row)"
                ></a>
              </div>
            </template>
          </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import moment from 'moment';
import { mapState } from 'vuex';
export default {
  name: 'Trip',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: null,
      tripTable: null,
      parameters:{},
      statusValue: '',
      columns: [
        'tripCode',
        'routeIdName',
        'driverIdDriverName',
        'vehicleIdRegNo',
        'startSiteSiteName',
        'endSiteSiteName',
        'scheduleDate',
        'scheduleTime',
        'createdAt',
        'status',
        'edit'
      ],
      options: {
        highlightMatches: true,
        sortable: [
          'tripCode',
          'routeIdName',
          'driverIdDriverName',
          'vehicleIdRegNo',
          'startSiteSiteName',
          'endSiteSiteName',
          'scheduleDate',
          'createdAt',
          'scheduleTime',
          'status'
        ],
        headings: {
          tripCode: 'Trip Id',
          routeIdName: 'Route',
          driverIdDriverName: 'Driver',
          vehicleIdRegNo: 'Vehicle',
          startSiteSiteName: 'Source',
          endSiteSiteName: 'Destination',
          scheduleDate: 'Schedule Date',
          scheduleTime: 'Schedule Time',
          createdAt : 'Schedule At(JM)',
          status: 'Status'
        },
        templates: {
          scheduleDate(row, query) {
            return `${moment(`${query.scheduleDate}`).format('DD-MM-YYYY')}`;
          },
          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          createdAt(row,query){
            return moment(`${query.createdAt}`).format('hh:mm A');
          },
          scheduleTime(row,query){
            if (query.scheduleTime){
              var [h,m] = query.scheduleTime.split(":");
              return `${(h%12+12*(h%12==0))}${":"}${ m} ${h >= 12 ? 'PM' : 'AM'}`;
            }
          }
        },
        requestFunction: request => {
          this.parameters.$page = request.page;
          this.parameters.$limit = request.limit;
          if(this.user.roleName == "GA Head"){
            console.log("partam",this.parameters)
            this.parameters.regionManager = this.user._id
          }
          if(this.user.roleName == "Journey Manager"){
            this.parameters.journeyManager = this.user._id
          }
          if (request.orderBy) {
            this.parameters.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            this.parameters.$sort = '-scheduleDate'
          }
          if (request.query) {
            this.parameters.$term = request.query;
          }else{
            delete this.parameters.$term
          }

          if (request.query.status) {
            this.parameters.status = request.query.status;
          }
          this.loading = true;
          return this.$tripDataRepository
            .list(this.parameters)
            .catch(error => {
              console.error('trip.requestFunction-error:', error);
              this.$snotify.error('Get Trip', 'Error!');
            });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.tripTable) {
        return this.tripTable.count > this.tripTable.limit ||
          this.tripTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user,
      
    }),
  },
  methods: {
    clearStatus(){
      delete this.parameters['status'];
      this.statusValue = '';
      this.$refs.tripTable.refresh();
    },
    fiteredResult(e){
      if (e.target.value == 'ongoing'){
        this.parameters = {
          ...this.parameters,
          status: 'ongoing',
        };
      }
      if (e.target.value == 'scheduled'){
          this.parameters = {
          ...this.parameters,
          status: 'scheduled',
        };
      }
      if (e.target.value == 'completed'){
          this.parameters = {
          ...this.parameters,
          status: 'completed',
        };
      }
      if (e.target.value == 'cancelled'){
          this.parameters = {
          ...this.parameters,
          status: 'cancelled',
        };
      }
      this.$refs.tripTable.refresh();
    },
    UpdateDestination(row) {
      if (row.status == 'ongoing'){
      this.$router.push({
        name: 'UpdateDestination',
        params: {
          _id: row._id,
        },
        props: row,
      });
    }
    },
    edit(data) {
      if ((data.row.status == 'ongoing') || (data.row.status == 'completed') ){
        this.$router.push({
          name: 'TripActivity',
          params: { _id: data.row._id},
          props: data.row,
        });
      }
      else if (data.row.status == 'scheduled') {
        this.$router.push({
          name: 'TripDetail',
          params: { _id: data.row._id},
          props: data.row,
        });
      }
    },
    onLoaded() {
      this.tripTable = this.$refs.tripTable;
    },
  },
};
</script>
<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width:225px;
  margin-left: 250px
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.inline{
  background-color: rgba(255, 132, 78);
    color: white
}
.addnew{
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
        color: white
}
</style>



// WEBPACK FOOTER //
// Trip.vue?3195d38a